<div class="announcement-banner-container flex-column width-full" #announcementBanner>
    <div class="announcement-banner" *ngFor="let announcement of announcements">
        <div class="announcement">
            <div class="announcement-content">
                {{ announcement.announcementContent }}
            </div>
            <div *ngIf="announcement.announcementLink" class="announcement-link">
                <a (click)="goToLink(announcement.announcementLink)"
                    >{{ 'MapViewer.AnnouncementBanner.AnnouncementLink.Placeholder' | translate }} ></a
                >
            </div>
        </div>
        <div class="close-notification">
            <gsp-button
                [type]="ButtonType.Icon"
                (action)="dismissAnnouncement(announcement.announcementId)"
                [iconClass]="'icon_line_cancel_white_24 i24'"
            ></gsp-button>
        </div>
    </div>

    <ng-container *ngIf="user.role === UserRole.ADMIN">
        <div
            *ngIf="showTaskMigrationBanner || showTaskMigrationFailedBanner || showTaskMigrationCompletedBanner"
            class="announcement-banner task-migration"
        >
            <div class="announcement">
                <div *ngIf="showTaskMigrationFailedBanner; else migrationDone" class="announcement-content">
                    {{ 'MapViewer.AnnouncementBanner.TaskMigration.FailedMessage' | translate }}
                </div>
                <ng-template #migrationDone>
                    <div *ngIf="showTaskMigrationCompletedBanner; else notCompleted" class="announcement-content">
                        {{ 'MapViewer.AnnouncementBanner.TaskMigration.CompletedMessage' | translate }}
                    </div>
                </ng-template>
                <ng-template #notCompleted>
                    <div *ngIf="showTaskMigrationBanner" class="announcement-content">
                        {{ 'MapViewer.AnnouncementBanner.TaskMigration.Message' | translate }}
                    </div>
                </ng-template>
            </div>

            <div *ngIf="showTaskMigrationBanner" class="migrate-action-button">
                <gsp-button
                    [type]="ButtonType.Default"
                    (action)="startMigration()"
                    text="{{ 'MapViewer.AnnouncementBanner.TaskMigration.MigrateButton' | translate }}"
                >
                </gsp-button>
            </div>

            <div class="close-notification">
                <gsp-button
                    [type]="ButtonType.Icon"
                    (action)="closeTaskMigrationBanner(true)"
                    [iconClass]="'icon_line_cancel_white_24 i24'"
                ></gsp-button>
            </div>
        </div>
    </ng-container>
</div>
